import BaseFormPresenter from "../../../base/BaseFormPresenter";

class ClientsFormPagePresenter extends BaseFormPresenter {
  constructor(view, getObjectUseCase, deleteObjectUseCase, upsertUseCase) {
    super(view, getObjectUseCase, deleteObjectUseCase, upsertUseCase);
    this.getObjectUseCase = getObjectUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
    this.upsertUseCase = upsertUseCase;
  }

  async onSubmit(obj) {
    const collection = this.view.getCollectionName();
    const isAdmin = this.view.isAdmin();
    const user = this.view.getCurrentUser();
    const clientId = this.view.getClientId();

    let { hasTin, ...updatedObject } = obj;

    updatedObject.name = updatedObject?.companyName;
    try {
      this.view.showLoading();
      if (clientId) {
        updatedObject.user = { id: clientId };
      }

      //If admin/accountantis creating a new direct client it will also create a new user
      if (isAdmin && !obj?.id && !clientId) {
        const user = { ...obj.user };
        const { username } = user;
        const isAllLowerCase = username === username.toLowerCase();

        if (!isAllLowerCase) {
          this.view.hideLoading();

          return this.view.showWarning("Username must be all lowercase.");
        }

        if (user.password !== user.reEnterPassword) {
          this.view.hideLoading();

          return this.view.showWarning(
            "Confirm Password doesn't match Password",
          );
        }

        delete user.reEnterPassword;
        delete updatedObject.user;

        updatedObject.clientOf = "admin";
        user.client = { ...updatedObject };
        const userObject = await this.upsertUseCase.execute("users", user);
      } else {
        if (updatedObject.editor) {
          updatedObject.editor = { id: updatedObject.editor?.id };
        }

        if (updatedObject.creator) {
          updatedObject.creator = { id: updatedObject.creator.id };
        }

        if (updatedObject?.user?.id) {
          updatedObject.user = { id: updatedObject?.user?.id };
        } else if (!isAdmin && !updatedObject?.user?.id) {
          updatedObject.user = { id: user?.id };
        }

        const object = await this.upsertUseCase.execute(
          collection,
          updatedObject,
        );
      }

      this.view.hideLoading();
      this.view.navigateBack();
      if (!updatedObject.id) {
        this.view.showSuccess("Submitted Successfully!");
      } else {
        this.view.showSuccess("Data Updated Successfully!");
      }
    } catch (error) {
      this.view.hideLoading();
      this.view.showError(error);
    }
  }
}

export default ClientsFormPagePresenter;
